window.angular.module('MyHippoProducer.Components').directive('fieldLabel', function () {
    return {
        restrict: 'AE',
        transclude: true,
        templateUrl: 'components/form/label/label.html',
    };
});
